<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
        <el-form-item label="产品编号" prop="productCode">
          <el-select v-model="dataForm.productCode" placeholder="产品编号">
          <el-option 
             v-for="item in productCode"
             :key="item.value"
             :label="item.label"
             :value="item.value"
          ></el-option>
        </el-select>
          <!-- <el-input v-model="dataForm.productCode" placeholder="产品编号"></el-input> -->
      </el-form-item>
          <el-form-item label="产品名称" prop="productName">
          <el-input v-model="dataForm.productName" placeholder="产品名称"></el-input>
      </el-form-item>
       <el-form-item label="是否启用" prop="isEnable">
          <el-radio-group v-model="dataForm.isEnable">
            <el-radio :label="1">有效</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
         
      </el-form-item>
          <el-form-item label="产品版本" prop="productVersion">
          <el-input v-model="dataForm.productVersion" placeholder="产品版本"></el-input>
      </el-form-item>
          <el-form-item label="版本号" prop="version">
          <el-input v-model="dataForm.version" placeholder="版本号"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  created(){
     // 文件类型
    //  this.$http.get(`/sys/dict/data/list?dataType=file_type`).then(r=>{
    //   console.log(r)
    //  this.file_type = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    // })
    // this.$http.get(`/sys/dict/data/list?dataType=signState`).then(r=>{
    //   console.log(r)
    //  this.signState = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    // })

    this.$http.get('/loan/tproduct/page',{
      page: 1,
      limit: 1000,
    }).then(r => {
     this.productCode = r.data.data.list.map(item => ({value:item.productCode,label:item.productName
      }))
      console.log(r.data.data.list)
    })
    
  },
  data () {
    return {
      visible: false,
      productCode:[],
      dataForm: {
        id: '',
        productCode: '',
        productName: '',
        isEnable: '',
        productVersion: '',
        createTime: '',
        createBy: '',
        updateTime: '',
        updateBy: '',
        version: '',
        remark: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        productCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isEnable: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productVersion: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        version: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/loan/tproduct/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/loan/tproduct/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
